import { useEffect, useState } from 'react';

import { type IconComponent } from '@air/design-icons';

// @air/design-icons builds every icon with React.forwardRef, which returns an object, not a function.
const isIconComponent = (value: unknown): value is IconComponent =>
  typeof value === 'function' || (typeof value === 'object' && value !== null && '$$typeof' in value);

let designIconsPromise: Promise<Record<string, unknown>> | null = null;

const loadDesignIcons = () => {
  designIconsPromise ??= import('@air/design-icons').then((module) => {
    const icons: Record<string, unknown> = {};

    for (const [name, icon] of Object.entries(module)) {
      icons[name] = icon;
    }

    return icons;
  });

  return designIconsPromise;
};

export const useAnnouncementIcon = (name: string | undefined): IconComponent | null => {
  const [icons, setIcons] = useState<Record<string, unknown> | null>(null);

  useEffect(() => {
    if (!name) {
      return;
    }

    let cancelled = false;

    void loadDesignIcons().then((loaded) => {
      if (!cancelled) {
        setIcons(loaded);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [name]);

  if (!name || !icons) {
    return null;
  }

  const Icon = icons[name];

  if (!isIconComponent(Icon)) {
    return null;
  }

  return Icon;
};
